<ion-header class="header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          [routerLink]="[breadcrumb.link]"
          routerDirection="back"
          detail="false"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
    </ion-buttons>
    <ion-title>
      <span [innerHTML]="'LEARNING_MODULES.TITLE' | translate"></span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="learning-modules">
  <div class="learning-modules__list">
    <ng-container *ngFor="let learningModule of learningModules$ | async">
      <div
        *ngIf="learningModule.visible"
        class="learning-modules__list__item"
        [appBackgroundImage]="learningModule | learningModulesDefaultImage"
        (click)="handleModuleClick(learningModule)"
      >
        <h3 class="learning-modules__list__item__title" [ngStyle]="{ background: learningModule.color }">
          <span [innerHTML]="learningModule.name"></span>
          <ion-icon *ngIf="!(learningModule.id | isModuleUnlocked | async)" name="lock-closed"></ion-icon>
        </h3>
      </div>
    </ng-container>
  </div>
</ion-content>
